export default __webpack_public_path__ + "media/workbench/canvas_background-752462de.png";